<template>
    <div>
      <hp5-button-decorator type="tertiary" size="md">
        <button v-on:click="onToggle" :data-card-rank="rank" :aria-label="ariaLabel">
          {{ buttonLabel }}
        </button>
      </hp5-button-decorator>
    </div>
</template>
  
<script setup>
  
    const props = defineProps({
        name: String,
        rank: Number
    })

    const emit = defineEmits(['toggle'])
  
    const toggle = ref(false)
    const buttonLabel = computed(() => (toggle.value ? '- Hide map' : '+ Show map'))
    const ariaLabel = computed(() => (toggle.value ? 'hide map of ' + props.name : 'show map of ' + props.name))

    const onToggle = () => {
        toggle.value = !toggle.value
        emit('toggle', toggle.value)
    }
  
</script>